import HeaderSection from '../../../../../components/Header/HeaderSection';
import CardTransparent from '../../../../../components/CockpitCards/CardTransparent';


export default function MouthTeethText() {

    
    return (

     <CardTransparent content = {
        <HeaderSection

            headline_p1 = "Protect Your " 
            headline_grey = "Teeth Health"
            headline_p2 = "from tooth decay and plaque buildup"

            text1 = "Protecting your teeth from caries (tooth decay) involves consistent oral hygiene, dietary habits, and regular dental care."
            text2 = "Your mouth is also home to your oral microbiome — billions of bacteria and fungi. Some cause inflammation, some lead to bad breath, while others keep us healthy."
            text3 = "We test your oral microbiome, identifying the bacteria causing problems and help you get rid of them."

            />
    }/>
            
  )
}